import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { Mediator } from '@spotahome/soyuz-mediator';

import { formatPrice } from '@spotahome/soyuz-currency';

import DSIcon from '../../../base/DSIcon';

import { COST_TYPE_CUSTOM, FREQUENCY_ONE_PAYMENT } from '../../constants/costs';

import { OPEN_GUARANTEE_MODAL } from '../utils/constants';

import { ListingCostItemShape } from '../../constants/shapes';

import PaymentTimelineCard from './PaymentTimelineCard';

import styles from './Extra.module.scss';

const ICONS_DICTIONARY = {
  contractRegistration: 'check_circle_transparent',
  latePayment: 'verified_card',
  earlyDepartureNoticePeriodBroken: '',
  extraTenant: 'perfect_for_couples',
  overnightGuest: 'perfect_for_couples',
  petFee: 'pets_allowed',
  outOfHoursCheckIn: 'faster',
  outOfHoursCheckOut: 'faster',
  checkOutCleaning: 'cleaning_service',
  council: 'bank_court_house',
  local: 'private_landlord',
  building: 'cottage',
  laundry: 'washing_machine',
  streaming: 'tv',
  custom: 'diamond',
  periodicCleaning: 'cleaning_service',
  parking: 'private_parking',
  bedLinen: 'bed_linen',
  meal: 'meal_service'
};

const Extra = ({ costs = {}, currencyCode }) => {
  const handleCostClick = cost => () => {
    let price;
    if (cost.value) {
      const formattedPrice = formatPrice(cost.value, currencyCode);
      price =
        cost.frequency === FREQUENCY_ONE_PAYMENT
          ? formattedPrice
          : trans('price.per.month', { price: formattedPrice }); // the price comes formatted for monthly payments
    }

    Mediator.publish(OPEN_GUARANTEE_MODAL, {
      title: cost.name || (
        <p className={styles.extra__title}>
          {ICONS_DICTIONARY[cost.type] && (
            <DSIcon name={ICONS_DICTIONARY[cost.type]} />
          )}
          <span className={styles['extra__title-type']}>
            {trans(`payment.timeline.cost.label.${cost.type}`)}
          </span>
        </p>
      ),
      body: cost.description || (
        <>
          <p>{trans(`payment.timeline.cost.label.${cost.type}.description`)}</p>
          {price ? <p className={styles.extra__price}>{price}</p> : null}
          <p
            dangerouslySetInnerHTML={{
              __html: trans('payment.timeline.cost.label.extra.ask-landlord')
            }}
          />
        </>
      )
    });
  };

  return costs?.costs?.length > 0 ? (
    <PaymentTimelineCard
      title={trans('payment.timeline.section.extra.title')}
      subtitle={trans('payment.timeline.section.extra.subtitle')}
      outlined={false}
      gapSpacing="big"
      tags={costs?.costs?.map(cost => ({
        label:
          cost.type === COST_TYPE_CUSTOM
            ? cost.name
            : trans(`payment.timeline.cost.label.${cost.type}`),
        renderLeadingIcon: () =>
          ICONS_DICTIONARY[cost.type] ? (
            <DSIcon name={ICONS_DICTIONARY[cost.type]} />
          ) : null,
        onClick: handleCostClick(cost),
        isSpaced: true,
        underlined: true,
        size: 'big',
        colorSchema: 'light'
      }))}
    />
  ) : null;
};

Extra.propTypes = {
  costs: PropTypes.shape(ListingCostItemShape),
  currencyCode: PropTypes.string.isRequired
};

export default Extra;
